<nav class="w-full sticky top-0 border-b border-gray-600 p-4 flex justify-between items-center px-8 py-4 bg-white z-10">
  <div class="flex gap-4">
    <!-- <button class="hidden lg:block xl:hidden" (click)="asideService.toggleIconsFullMenu()">
      <svg *ngIf="asideState.type == 'full'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-left">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M11 7l-5 5l5 5" />
        <path d="M17 7l-5 5l5 5" />
      </svg>
      <svg *ngIf="asideState.type == 'icons'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-right">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M7 7l5 5l-5 5" />
        <path d="M13 7l5 5l-5 5" />
      </svg>
    </button> -->
    <button (click)="asideService.openMobileMenu()" class="block xl:hidden">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-menu-2">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 6l16 0" />
        <path d="M4 12l16 0" />
        <path d="M4 18l16 0" />
      </svg>
    </button>
    <div class="flex flex-col justify-start items-start gap-0 animate-fade-in" *ngIf="breadcrumbs">
      <span class="font-[400] text-darkGray">{{ breadcrumbs.display_name }}</span>
      <div>
        <ng-container *ngFor="let item of breadcrumbs.items; let last = last">
          <a *ngIf="item.url" [routerLink]="item.url" class="text-xs text-lightGray hover:text-darkGray">{{ item.name
            }}</a>
          <span *ngIf="!item.url" class="text-xs text-lightGray ">{{ item.name }}</span>
          <span class="text-xs text-lightGray" *ngIf="!last"> - </span>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="flex items-center justify-end gap-4" *ngIf="user">
    <div class="flex gap-2 items-center justify-center">
      <span class="text-xs" *ngIf="user"></span>

      <div class="mr-10">
        <div *ngIf="!isProfessional">
          <a (click)="resetBookForm()" routerLink="/dashboard/nueva-cita"
            class="bg-green2 text-green border border-green px-4 py-2 rounded-lg w-full md:w-auto text-center block">
            <span class="inline text-sm">Nueva cita</span>
          </a>
        </div>

        <div *ngIf="isProfessional">
          <a (click)="resetBookForm()" routerLink="/"
            class="bg-green2 text-green border border-green px-4 py-2 rounded-lg w-full md:w-auto text-center block">
            <span class="inline text-sm">Nueva cita</span>
          </a>
        </div>
      </div>

      <span class="hidden md:block text-darkGray text-xs animate-fade-in cursor-pointer" (click)="toggleMenu($event)">
        {{ user.profile.name }}
      </span>

      <div class="relative">
        <img [alt]="user.profile.name"
          ngSrc="https://ui-avatars.com/api/?name={{user.profile.name.replace(' ', '+')}}&background=168FFB&color=fff&size=128"
          class="object-cover w-10 h-10 rounded-full cursor-pointer" height="10" width="10"
          (click)="toggleMenu($event)" />

        <div *ngIf="showMenu"
          class="absolute -right-7 mt-4 w-64 bg-white shadow-sm border border-gray-200 rounded-lg p-4 duration-150 animate-slide-in-top"
          [ngClass]="{ 'opacity-100 scale-100': showMenu, 'opacity-0 scale-95': !showMenu }">
          <div class="flex gap-4 justify-center items-center mb-3">
            <a href="#" onclick="doGTranslate('es|es');return false;" title="Español" id="español"
              class="glink nturl notranslate border-2 border-lightGray rounded-full py-3 px-2 hover:shadow-lg">
              <img class="w-8" src="/assets/img/es.svg" alt="Español" />
            </a>
            <a href="#" onclick="doGTranslate('es|ca');return false;" title="Catalá" id="catala"
              class="glink nturl notranslate border-2 border-lightGray rounded-full py-3 px-2 hover:shadow-lg">
              <img class="w-8" src="/assets/img/ca.png" alt="Catalá" />
            </a>
          </div>

          <!-- Botón de logout -->
          <button
            class="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-lg flex items-center justify-center gap-2 text-sm"
            (click)="logOutAndCloseMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" stroke="currentColor"
              stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
              <path d="M9 12h12l-3 -3" />
              <path d="M18 15l3 -3" />
            </svg>
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>